export const HEADER_KEY = '@@header';

export const ActionTypes = {
    CLICK_JOIN: `${HEADER_KEY}/CLICK_JOIN`,
    CLICK_SIGN_IN: `${HEADER_KEY}/CLICK_SIGN_IN`,
    TRACK_MOBILE_MENU_LINK_CLICK: `${HEADER_KEY}/TRACK_MOBILE_MENU_LINK_CLICK`,
    TRACK_NOTIFICATION_CLICK: `${HEADER_KEY}/TRACK_NOTIFICATION_CLICK`,
    TRACK_NOTIFICATIONS_COUNTER_CLICK: `${HEADER_KEY}/TRACK_NOTIFICATIONS_COUNTER_CLICK`,
    TRACK_PAGEHEADER_CTALINK_CLICK: `${HEADER_KEY}/TRACK_PAGEHEADER_CTALINK_CLICK`,
    TRACK_PAGEHEADER_LOGO_CLICK: `${HEADER_KEY}/TRACK_PAGEHEADER_LOGO_CLICK`,
    TRACK_SEE_ALL_NOTIFICATIONS: `${HEADER_KEY}/TRACK_SEE_ALL_NOTIFICATIONS`,
    TRACK_SIGNIN_DROPDOWN_CLICK: `${HEADER_KEY}/TRACK_SIGNIN_DROPDOWN_CLICK`,
    TRACK_SIGNIN_DROPDOWN_LINK_CLICK: `${HEADER_KEY}/TRACK_SIGNIN_DROPDOWN_LINK_CLICK`,
    TRACK_UPCOMING_APPOINTMENTS_CLICK: `${HEADER_KEY}/TRACK_UPCOMING_APPOINTMENTS_CLICK`,
    TRACK_USERNAME_DROPDOWN_CLICK: `${HEADER_KEY}/TRACK_USERNAME_DROPDOWN_CLICK`,
    TRACK_USERNAME_DROPDOWN_LINK_CLICK: `${HEADER_KEY}/TRACK_USERNAME_DROPDOWN_LINK_CLICK`,
    TRACK_UNIVERSAL_SEARCH_HEADER_SUBMIT: `${HEADER_KEY}/TRACK_UNIVERSAL_SEARCH_HEADER_SUBMIT`,
};
